export const titles = {
  issuerTitle: 'Тісто',
};
